import { createContext, useContext, useState } from 'react';
type GlobalSearchProviderProps = { children: React.ReactNode };
interface IGlobalSearch {
  globalSearchValue: string;
  SetGlobalSearchValue: (value: string) => void;
}
const GlobalSearchContext = createContext<IGlobalSearch | undefined>(undefined);
export function GlobalSearchProvider({ children }: GlobalSearchProviderProps) {
  const [globalSearchValue, setGlobalSearchValue] = useState('');
  function SetGlobalSearchValue(value: string) {
    setGlobalSearchValue(value);
  }
  const contextValue: IGlobalSearch = {
    globalSearchValue,
    SetGlobalSearchValue,
  };

  return <GlobalSearchContext.Provider value={contextValue}>{children}</GlobalSearchContext.Provider>;
}

export function useGlobalSearch(): IGlobalSearch {
  const context = useContext(GlobalSearchContext);
  if (context === undefined) {
    throw new Error('useGlobalSearch must be used within a GlobalSearchProvider');
  }
  return context;
}
